import { render, staticRenderFns } from "./SelectColored.vue?vue&type=template&id=05b33bd0"
import script from "./SelectColored.vue?vue&type=script&lang=ts"
export * from "./SelectColored.vue?vue&type=script&lang=ts"
import style0 from "./SelectColored.vue?vue&type=style&index=0&id=05b33bd0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports